var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3d4f42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1127.3 227h-1054.7c-10.355 0-18.75-8.3945-18.75-18.75v-92.523c0-10.355 8.3945-18.75 18.75-18.75h1054.7c10.355 0 18.75 8.3945 18.75 18.75v92.523c0 10.355-8.3945 18.75-18.75 18.75zm-1035.9-37.5h1017.2v-55.023h-1017.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1080.5 1103h-101.51c-10.355 0-18.75-8.3945-18.75-18.75v-876.02c0-10.355 8.3945-18.75 18.75-18.75h101.51c10.355 0 18.75 8.3945 18.75 18.75v876.02c0 10.355-8.3945 18.75-18.75 18.75zm-82.758-37.5h64.008v-838.52h-64.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.96 1103h-101.51c-10.355 0-18.75-8.3945-18.75-18.75v-876.02c0-10.355 8.3945-18.75 18.75-18.75h101.51c10.355 0 18.75 8.3945 18.75 18.75v876.02c0 10.355-8.3945 18.75-18.75 18.75zm-82.758-37.5h64.008v-838.52h-64.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.55 937.02h-457.09c-10.355 0-18.75-8.3945-18.75-18.75v-104c0-10.355 8.3945-18.75 18.75-18.75h457.09c10.355 0 18.75 8.3945 18.75 18.75v104c0 10.355-8.3945 18.75-18.75 18.75zm-438.34-37.5h419.59v-66.504h-419.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.03 833.01c-10.355 0-18.75-8.3945-18.75-18.75v-536.25c0-10.355 8.3945-18.75 18.75-18.75 10.355 0 18.75 8.3945 18.75 18.75v536.25c0 10.355-8.3945 18.75-18.75 18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m808.97 833.01c-10.355 0-18.75-8.3945-18.75-18.75v-536.25c0-10.355 8.3945-18.75 18.75-18.75 10.355 0 18.75 8.3945 18.75 18.75v536.25c0 10.355-8.3945 18.75-18.75 18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.84 296.76h-111.62c-10.355 0-18.75-8.3945-18.75-18.75v-69.754c0-10.355 8.3945-18.75 18.75-18.75h111.62c10.355 0 18.75 8.3945 18.75 18.75v69.754c0 10.355-8.3945 18.75-18.75 18.75zm-92.875-37.5h74.125v-32.254h-74.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m864.79 296.76h-111.62c-10.355 0-18.75-8.3945-18.75-18.75v-69.754c0-10.355 8.3945-18.75 18.75-18.75h111.62c10.355 0 18.75 8.3945 18.75 18.75v69.754c0 10.355-8.3945 18.75-18.75 18.75zm-92.875-37.5h74.125v-32.254h-74.125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.6fc92ac908f0e04adcdb47a97b70c56d.svg";
export { ForwardRef as ReactComponent };